import { createSlice } from "@reduxjs/toolkit";
import { authUser } from "./authThunks";

const authSlice = createSlice({
    name: "auth",
    initialState: {
        user: {},
        token: null,
        loading: false,
        backendAuthErrors : {},
        serverError: {},
        networkError : null
    },
    reducers : {
        cleanBackendErrors  : (state) => {
            state.backendAuthErrors = {};
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(authUser.pending, (state) => {
                state.loading = true;
                state.backendAuthErrors = {};
                state.serverError = {};
                state.networkError = null;
            })
            .addCase(authUser.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload.user;
                state.token = action.payload.token;
            })
            .addCase(authUser.rejected, (state, action) => {
                state.loading = false;
                state.backendAuthErrors = action.payload?.backendAuthErrors;
                state.serverError = action.payload?.serverError;
                state.networkError = action.payload?.networkError;
            });
    }
});

export const {cleanBackendErrors} = authSlice.actions;
export default authSlice.reducer;

